import { Button, Typography } from '@/components';
import { AnnouncementLabel } from '@/components/Layout/Header/Header.styles';
import { TextStyles } from '@/constants';
import { ButtonColorKey, ButtonSize, ButtonVariant } from '@/interfaces';
import styled from 'styled-components';

export const EmailSyncCTAWrapper = styled.div({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: 4,
});

export const MainGraphic = styled.img({
  display: 'block',
  width: '100%',
});

export const EmailSyncCTAContent = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.darkBlue,
  padding: theme.spacing[16],
  textAlign: 'center',
}));

export const MainText = styled(Typography).attrs({
  variant: TextStyles['Heading 3'],
})(({ theme }) => ({
  color: theme.colors.highEmphasisWhite,
  marginBottom: theme.spacing[12],
  wordBreak: 'break-word',
}));

export const JoinUsButton = styled(Button).attrs({
  variant: ButtonVariant.Outlined,
  color: ButtonColorKey.Transparent,
  size: ButtonSize.Medium,
})(({ theme }) => ({
  width: '100%',
  color: theme.colors.highEmphasisWhite,
  border: `solid 1px ${theme.colors.highEmphasisWhite}`,

  [':not([disabled]):hover']: {
    backgroundColor: theme.colors.hoverBlack,
  },
}));

export const NewLabel = styled(AnnouncementLabel)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing[8],
  right: theme.spacing[8],
  border: `solid 1px ${theme.colors.highEmphasisWhite}`,
  marginLeft: 0,
}));
